const fields = {
  config: {
    columns: 1
  },
  fields: [
    {
      name: "id",
      column: 1,
      type: "unvisible"
    },
    {
      name: "minDaysCount",
      label: "Minimalna liczba dni",
      column: 1,
      type: "number",
      mandatory: true
    },
    {
      name: 'dates',
      label: 'Limit obowiązuje od - do',
      column: 1,
      type: 'dateRange',
      mandatory: true,
      startField: 'startDate',
      endField: 'endDate',
      excludedDates: [],
      excludedStartDates: [],
      excludedEndDates: [],
      fromLabel: 'Data startu',
      toLabel: 'Data końca',
    },
  ]
};

export default fields;
